module.exports = __webpack_public_path__ + "static/media/upp_flo_sta_pro.8d42906e.png";